export const faqItems = [
  {
    question: '什么是 ASMR 助眠？',
    answer: 'ASMR（Autonomous Sensory Meridian Response，自发性知觉经络反应）是一种通过特定声音或视觉刺激引发的放松反应。ASMR 助眠利用雨声、耳语、敲击音等触发音效，帮助大脑放松、减缓思绪，从而促进自然入睡。',
  },
  {
    question: '听 ASMR 助眠安全吗？有副作用吗？',
    answer: 'ASMR 助眠是安全的非药物助眠方式。只要控制好音量（建议不超过60分贝），不会对听力造成伤害。建议使用外放或骨传导耳机，避免长时间佩戴入耳式耳机入睡。',
  },
  {
    question: '每天听多久 ASMR 比较合适？',
    answer: '建议每天睡前收听20-40分钟。如果中途已经入睡，可以设置定时关闭。不建议整夜持续播放，给耳朵适当的休息时间很重要。',
  },
  {
    question: '为什么有些人听 ASMR 没有感觉？',
    answer: 'ASMR 反应因人而异，大约20%-30%的人可能感受不到明显的"酥麻感"。但这不代表 ASMR 对您无效——即使没有触发感，这些舒缓声音仍然具有放松和助眠效果。建议尝试不同类型的触发音，找到最适合自己的。',
  },
  {
    question: '什么样的耳机最适合听 ASMR？',
    answer: '推荐使用降噪耳机或封闭式头戴耳机，能更好地还原 ASMR 音频中的空间感和细节。睡前收听建议使用专门的睡眠耳机（超薄设计）或枕头音箱，更加舒适安全。',
  },
  {
    question: 'ASMR 能替代安眠药吗？',
    answer: 'ASMR 可以作为改善睡眠的辅助手段，但不能完全替代药物治疗。如果您正在服用安眠药，请在医生指导下逐步调整用药方案，切勿自行停药。ASMR 更适合轻度失眠和入睡困难的人群。',
  },
  {
    question: '什么时间段听 ASMR 效果最好？',
    answer: '睡前30-60分钟是最佳收听时间。此时身体开始分泌褪黑素，配合 ASMR 的放松效果能加速入睡过程。午休时收听15-20分钟也有助于快速恢复精力。',
  },
  {
    question: '小孩可以听 ASMR 助眠吗？',
    answer: '可以，但需要选择合适的类型。建议选择雨声、海浪声等自然音效，避免耳语和角色扮演类内容。音量控制在40分贝以下，并在家长监护下使用。',
  },
];